// Purpose: Share account signup controls between entry submission and candidate review.
// Dependencies: React; callers own credential state and normal signup orchestration.
// Behavior: Existing sessions never create another account; guest passwords remain opt-in and ephemeral.
import React from "react";

export default function EntryAccountSignup({ user, accountCreated, createAccount, onCreateAccountChange, password, onPasswordChange, agreedToTerms, onTermsChange, disabled }) {
  if (user && !accountCreated) return (
    <div className="alert alert-info mt-4" role="status">
      You are signed in as {user.email || "an existing account"}. No password is needed here.
    </div>
  );
  return (
    <div className="border rounded p-3 mt-4">
      <div className="form-check">
        <input id="entry-create-account" type="checkbox" className="form-check-input" checked={createAccount}
          disabled={disabled || accountCreated} onChange={(event) => onCreateAccountChange(event.target.checked)} />
        <label className="form-check-label fw-bold" htmlFor="entry-create-account">Create an account to get ready for the event</label>
      </div>
      {!accountCreated && <>
        <p className="form-text">Use the name and email above. Verify your email before voting.</p>
        <label className="form-label" htmlFor="entry-account-password">Password</label>
        <input id="entry-account-password" type="password" autoComplete="new-password" minLength={6}
          className="form-control" value={password} disabled={disabled || !createAccount}
          aria-describedby="entry-account-password-help" onChange={(event) => onPasswordChange(event.target.value)} />
        <div id="entry-account-password-help" className="form-text">Select “Create an account” above to enter a password. Minimum 6 characters.</div>
        <div className="form-check mt-3">
          <input id="entry-account-terms" type="checkbox" className="form-check-input" checked={agreedToTerms}
            disabled={disabled || !createAccount} onChange={(event) => onTermsChange(event.target.checked)} />
          <label className="form-check-label" htmlFor="entry-account-terms">I agree to the <a href="/terms" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></label>
        </div>
        <div className="form-text">Already registered? <a href="/login" target="_blank" rel="noopener noreferrer">Log in</a>, then return here.</div>
      </>}
    </div>
  );
}
